import * as React from 'react'

import { Box, Button, Section, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import authService, { Status as AuthStatus } from 'modules/integrations_silae_api/lib/authService'

import Tag from './Tag'

const IntegrationLinkStatus = () => {
  const { company } = useCurrentSession()
  const isBookkeeperView = useBookkeeperView()
  const companyId = company.id
  const [authStatus, setAuthStatus] = React.useState<AuthStatus>(AuthStatus.NotAvailable)

  const connect = async () => {
    await authService.connect(authStatus, companyId)
    fetchAuthStatus()
  }

  const fetchAuthStatus = async () => {
    setAuthStatus(
      await authService.getStatus({
        companyId: companyId,
        bookkeeperView: isBookkeeperView,
      })
    )
  }

  const { loading } = useAsyncData(async () => {
    await fetchAuthStatus()
  }, [])

  const show = !loading && authStatus !== AuthStatus.NotAvailable

  if (!show) return <></>

  return (
    <Section
      description={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_silae_api.settings.login.description'
      )}
      illustration="common-file-text-upload"
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_silae_api.settings.login.title'
      )}
    >
      <Box
        background="grey200"
        padding="s24"
        style={{ marginTop: '40px' }}
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <Text.Normal size="300" weight="semibold">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_silae_api.settings.login.status_card.title'
          )}
        </Text.Normal>

        {show && <Tag status={authStatus} />}

        {show && authStatus != AuthStatus.Authenticated && (
          <Button onClick={connect} type="secondary">
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_silae_api.settings.login.status_card.button'
            )}
          </Button>
        )}
      </Box>
    </Section>
  )
}

export default observer(IntegrationLinkStatus)
